import { render, staticRenderFns } from "./EventAttend.vue?vue&type=template&id=be61490a&scoped=true"
import script from "./EventAttend.vue?vue&type=script&lang=js"
export * from "./EventAttend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be61490a",
  null
  
)

export default component.exports